import { supabase } from "@/lib/supabase/client";
import type { PlanningRecordRepository, PlanningScope } from "@/data/repositories/planningRecordRepository";

type Row = { id: string; payload: Record<string, unknown> };

export class SupabasePlanningRecordRepository implements PlanningRecordRepository {
  async list<T extends { id: string }>(scope: PlanningScope): Promise<T[]> {
    let query = supabase
      .from("planning_records")
      .select("id,payload")
      .eq("organization_id", scope.organizationId)
      .eq("module", scope.module);
    query = scope.eventId ? query.eq("event_id", scope.eventId) : query.is("event_id", null);
    const { data, error } = await query.order("created_at", { ascending: true });
    if (error) throw error;
    return ((data ?? []) as Row[]).map((row) => ({ ...row.payload, id: row.id }) as T);
  }

  async save<T extends { id: string }>(scope: PlanningScope, value: T): Promise<void> {
    const { id, ...payload } = value;
    const table = supabase.from("planning_records") as unknown as {
      upsert(values: Record<string, unknown>): Promise<{ error: Error | null }>;
    };
    const { error } = await table.upsert({
      id,
      organization_id: scope.organizationId,
      event_id: scope.eventId ?? null,
      module: scope.module,
      payload,
    });
    if (error) throw error;
  }

  async remove(scope: PlanningScope, id: string): Promise<void> {
    const { error } = await supabase
      .from("planning_records")
      .delete()
      .eq("id", id)
      .eq("organization_id", scope.organizationId)
      .eq("module", scope.module);
    if (error) throw error;
  }
}
